<template>
  <div>
    <div class="top_text"><v-icon>beenhere</v-icon>소재별 그룹별 리포트</div>
    <div class="topTableWrap">
      <CgTable
        :viewData="viewData"
        :isExcel="isExcel"></CgTable>
    </div>
  </div>
</template>

<script>
  import CgTable from './CgTable'

  export default {
    name: 'creativeGroup_imp',
    props: {
      campaignType: String,
      viewData: Array
    },
    components: {
      CgTable
    },
    data () {
      return {
        isExcel: false
      }
    },
    mounted () {
      window.scroll(0, 0)
      document.body.scrollTop = 0
    }
  }
</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// CgImp.vue?58574062